/**
 * Dispatch Notification Settings Page
 *
 * Page wrapper for the notification settings component (Issue 6.3)
 * Route: /dispatch/settings/notifications
 */

import React from 'react';
import { DispatchNotificationSettings } from '../../containers/pages/CANguard/components/dispatchSettings';

function DispatchNotificationSettingsPage() {
  return <DispatchNotificationSettings />;
}

export default DispatchNotificationSettingsPage;
